<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">

              <a-form-item   style="margin-left: 10%;width: 80%">
                <div style="font-size: 16px;color:rgba(125, 133, 146, 1)">所属城市</div>
                <a-tree-select
                  v-decorator="['areaName', validatorRules.areaName]"
                  show-search
                  :disabled="formDisabled"
                  style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  :tree-data="cityList"
                  placeholder="请选择城市"
                  allow-clear
                  tree-default-expand-all
                >
                </a-tree-select>
              </a-form-item>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { getFileAccessHttpUrl,httpAction, getAction ,deleteAction} from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue,getDataSub,by_str } from '@/utils/util'
  export default {
    name: 'EditAreaForm',
    components: {

    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        validatorRules: {
          areaName: {
            rules: [
              { required: true, message: '请选择所属城市!'},
            ]
          }
        },
        url: {
          add: "/dm/dmDriver/add",
          edit: "/dm/dmDriver/editAreaName",
          queryById: "/dm/dmDriver/queryById"
        },
        userList:[],
        recruitList:[

        ],
        getDataSub:getDataSub,
        cityList:[]

      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data

    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'areaName'))
        })
        this.getCityList();
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = this.url.edit;

            let formData = Object.assign(this.model, values);
            getAction(httpurl,formData).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok',formData.areaName);
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'areaName'))
      },getCityList(){
        getAction("/dm/dmArea/listCity").then((res)=>{
          if(res.success){
            let city = res.result;
            if(city){
              let cityMap ={};
              for(let a in city){
                if(!cityMap[city[a].areaPy]){
                  cityMap[city[a].areaPy] = [];
                }
                cityMap[city[a].areaPy].push(city[a]);
              }
              let cityList = [];
              for(let b in cityMap){
                cityList.push({
                  firstPinyin:b,
                  city:cityMap[b]
                })
              }

              cityList.sort(by_str("firstPinyin"));
              let treeData = [];
              for(let c in cityList){
                let obj = {
                  selectable:false,
                  key:cityList[c].firstPinyin,
                  title:cityList[c].firstPinyin,
                  value:cityList[c].firstPinyin,
                  children:[]
                }
                if(cityList[c].city){
                  for(let d in cityList[c].city){
                    obj.children.push({
                      key:cityList[c].city[d].areaName,
                      title:cityList[c].city[d].areaName,
                      value:cityList[c].city[d].areaName,
                      isLeaf:true
                    });
                  }
                }
                treeData.push(obj);
              }
              this.cityList = treeData;
            }
          }else{
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>

  /deep/ .ant-list-item-meta-description{
    max-width: 400px;
  }
</style>